import { Locale } from '@/enums/locale'

export function extractLocaleFromPath(path: string): Locale {
  const segments = path.split('/').filter(Boolean)
  const locale = segments.find(segment => Object.values(Locale).includes(segment as Locale))
  return locale ? (locale as Locale) : Locale.EN
}